<template>
  <v-row
    class="align-center my-3"
  >
    <v-col>
      <v-row>
        <v-col class="mx-3">
          <v-row class="font-weight-medium">
            <span>Alias Mode</span>
          </v-row>

          <v-row
            v-if="isAliasWriter"
            class="caption"
          >
            View the app as an external user.
          </v-row>

          <v-row
            v-else
            class="caption"
          >
            <v-col class="px-0">
              <p>This account is aliasing <strong>{{ currentAliasEmail }}</strong>.</p>
            </v-col>
          </v-row>

          <v-row v-if="isAliasWriter">
            <v-col class="px-0 pb-0 col-grow">
              <v-combobox
                :items="aliasOptions"
                label="User Email"
                :value="currentAliasEmail"
                flat
                dense
                hide-details
                solo
                @change="updateAliasEmail"
              />
            </v-col>
          </v-row>

          <v-row
            v-if="isAliasWriter"
            class="justify-space-between mb-2"
          >
            <v-col class="pa-0 col-auto">
              <v-switch
                v-model="aliasActiveModel"
                active-class="primary--text"
                class="mt-2"
                hide-details
                :label="aliasActiveLabel"
                inset
              />
            </v-col>

            <v-col class="pr-0 col-auto">
              <v-btn
                color="primary"
                small
                @click.stop="updateAliasMode"
              >
                <span>Save</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-divider />
    </v-col>
  </v-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const { mapGetters: mapAuthGetters, mapState: mapAuthState } = createNamespacedHelpers('auth')

export default {
  data() {
    return {
      externals: [],
      selectedAliasEmail: null,
      toggleAliasActive: null,
    }
  },
  computed: {
    ...mapAuthGetters([
      'aliasEmail',
      'isAliasActive',
      'isAliasWriter',
    ]),
    ...mapAuthState({
      $aliasOptions: (state) => state.aliasOptions,
    }),

    currentAliasEmail: {
      get() {
        return this.selectedAliasEmail || this.aliasEmail || null
      },
      set(newValue) {
        this.selectedAliasEmail = newValue
      },
    },
    aliasActiveModel: {
      get() {
        return typeof this.toggleAliasActive === 'boolean' ? this.toggleAliasActive : this.isAliasActive
      },
      set(newValue) {
        this.toggleAliasActive = newValue
      },
    },
    aliasOptions() {
      return this.$aliasOptions || []
    },
    aliasActiveLabel() {
      return this.aliasActiveModel ? 'On' : 'Off'
    },
  },

  methods: {
    updateAliasEmail(selection) {
      this.selectedAliasEmail = selection.value
    },
    updateAliasMode() {
      const { aliasActiveModel, currentAliasEmail } = this
      const active = aliasActiveModel
      const email = currentAliasEmail
      const alias = { active, email }
      this.$store.dispatch('auth/updateAliasMode', alias, { root: true })
    },
  },
}
</script>
